import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromExport from "./export.reducer";

export const selectExportState = createFeatureSelector<fromExport.State>(fromExport.exportFeatureKey);

export const currentPartsForUserForExport = createSelector(selectExportState, (state) => state.parts);
export const loadingPartsForExport = createSelector(selectExportState, (state) => state.loadingParts);

export const numberOfPartsSelected = createSelector(selectExportState, (state) => {
	return state.parts.filter((part) => part.selected == true).length;
});

export const selectedReports = createSelector(selectExportState, (state) => {
	return state.parts
		.filter((part) => part.selected)
		.map((part) => part.reports)
		.reduce((acc, curr) => acc.concat(curr), []);
});

export const reportsLoading = createSelector(selectExportState, (state) => {
	return state.loadingReports;
});
